import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlFr extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items par page';
  nextPageLabel = 'Page suivante';
  previousPageLabel = 'Page précédente';
  firstPageLabel = 'Première page';
  lastPageLabel = 'Dernière page';

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    let itemLength: number = length;
    if (itemLength === 0 || pageSize === 0) {
      return `0 à ${itemLength}`;
    }
    itemLength = Math.max(itemLength, 0);
    const startIndex: number = page * pageSize;
    const endIndex = startIndex < itemLength ? Math.min(startIndex + pageSize, itemLength) : startIndex + pageSize;
    return `${startIndex + 1} à ${endIndex} (${itemLength} au total)`;
  };
}
